module.exports = __webpack_public_path__ + "img/appAsset-Branding--TemplateEmail-admiral.8759afc9.svg";